<template>
<v-app>
    <v-snackbar v-model="snackbar" top color="red" :timeout="4000">
        {{ errorMsg }}
        <v-btn color="white" icon @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
    <v-container fluid class="mt-10">
        <div v-if="loading" class="container">
          <p>Chargement en cours ...</p>
        </div>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-title>
                            Tarifs
                            <v-spacer></v-spacer>
                            <v-select :items="typeItems" label="Type" item-text="key" item-value="value" v-model="gammeType" dense></v-select>
                            <v-spacer></v-spacer>
                            <v-select :items="periodes" label="Periode" item-text="${data.item.datebegin}, ${data.item.dateend}`" item-value="id" v-model="periodeId" dense>
                                <template slot="selection" slot-scope="data">
                                    Du {{ data.item.datebegin | moment('YYYY-MM-DD')}} Au {{data.item.dateend | moment('YYYY-MM-DD')}}
                                </template>
                                <template slot="item" slot-scope="data">
                                    <v-list-tile-content>
                                        <v-list-tile-title>Du {{data.item.datebegin | moment('YYYY-MM-DD')}} Au {{data.item.dateend | moment('YYYY-MM-DD')}}</v-list-tile-title>
                                    </v-list-tile-content>
                                </template>
                            </v-select>
                        </v-card-title>
                        <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th :class="header.align" v-for="(header,j) in headers" :key="j">{{header.text}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="tar in tarifs">
                                        <template v-for="(tarif,index) in tar.dependencies">
                                            <tr :key="tarif.id">
                                                <td :rowspan="tar.nbVersion" v-if="index===0" style="border-right: thin solid rgba(0, 0, 0, 0.12) !important">{{tar.name}}</td>
                                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12) !important" class="text-left">{{tarif.version.nom}}</td>
                                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12) !important" class="text-right">{{FormatPrix(tarif.tarif.pvttc)}}</td>
                                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12) !important" class="text-right">{{FormatPrix(tarif.tarif.effortcommercial)}}</td>
                                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12) !important" class="text-right">{{FormatPrix(tarif.tarif.prixeffortcommercialmax)}}</td>
                                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12) !important" class="text-right">{{FormatPrix(tarif.tarif.peinturemetallisee)}}</td>
                                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12) !important" class="text-right">{{FormatPrix(tarif.tarif.fraisimmat)}}</td>
                                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12) !important" class="text-right" v-if="gammeType == 'VP'">{{FormatPrix(tarif.tarif.prixclesenmain)}}</td>
                                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12) !important" class="text-right" v-if="gammeType == 'VP'">{{FormatPrix(tarif.tarif.montantassurance)}}</td>
                                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12) !important" class="text-right">{{tarif.tarif.customdata.option1}}</td>
                                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12) !important;" class="text-center">
                                                    {{(tarif.tarif.customdata.conditionoption !== undefined ? tarif.tarif.customdata.conditionoption.toUpperCase() : '')}}
                                                </td>
                                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12) !important" class="text-right">{{tarif.tarif.customdata.option2}}</td>
                                                <td style="border-right: thin solid rgba(0, 0, 0, 0.12) !important" class="text-right">
                                                    <v-btn small text color="primary" v-on:click="openOffers(tarif)">Offres de financements</v-btn>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <!--
                    <v-card

                    >
                      <v-img
                          height="240"
                          src="https://www.hyundai.com/content/dam/hyundai/ma/fr/images/test/EXE%20KV%20site%20i20%20bleu.jpg"
                        >
                      </v-img>
                      <v-card-title>i20</v-card-title>
                      <v-divider class="mx-4"></v-divider>
                    </v-card>
                    -->
                </v-col>
            </v-row>
        </div>
    </v-container>
</v-app>
</template>

<script>
import NProgress from "nprogress";
import moment from 'moment';
export default {
    name: 'ViewTarifier',
    data() {
        return {
            gammeType: this.type,
            periodeId: '',
            unauthorized: false,
            loading: false,
            snackbar: false,
            errorMsg: "",
            today: moment(),
            headersVP: [
                {
                    text: 'Modèles',
                    align: 'text-center',
                    sortable: false,
                    value: 'dependencies.hmodele.name'
                },
                {
                    text: 'Version',
                    align: 'text-left',
                    sortable: false,
                    value: 'dependencies.hmodeleversion.nom',
                },
                {
                    text: 'Prix Vente Public T.T.C',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.pvttc',
                },
                {
                    text: 'Effort commercial Max',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.effortcommercial',
                },
                {
                    text: 'Prix Effort Commercial Max',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.prixeffortcommercialmax',
                },
                {
                    text: 'Frais Peinture métallisée',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.peinturemetallisee',
                },
                {
                    text: 'F.I',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.fraisimmat',
                },
                {
                    text: 'Prix clés en main max',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.prixclesenmain',
                },
                {
                    text: 'Montant Assurance',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.montantassurance',
                },
                {
                    text: 'Option 1',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.fraisimmat',
                },
                {
                    text: 'ET/OU',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.fraisimmat',
                },
                {
                    text: 'Option 2',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.fraisimmat',
                },
                {
                    text: 'Financement',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.fraisimmat',
                }
            ],
            headersLoueur: [
                {
                    text: 'Modèles',
                    align: 'text-center',
                    sortable: false,
                    value: 'dependencies.hmodele.name'
                },
                {
                    text: 'Version',
                    align: 'text-left',
                    sortable: false,
                    value: 'dependencies.hmodeleversion.nom',
                },
                {
                    text: 'Prix Vente Public T.T.C',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.pvttc',
                },
                {
                    text: 'Effort commercial Max',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.effortcommercial',
                },
                {
                    text: 'Prix Effort Commercial Max',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.prixeffortcommercialmax',
                },
                {
                    text: 'Frais Peinture métallisée',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.peinturemetallisee',
                },
                {
                    text: 'F.I',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.fraisimmat',
                },
                {
                    text: 'Option 1',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.fraisimmat',
                },
                {
                    text: 'ET/OU',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.fraisimmat',
                },
                {
                    text: 'Option 2',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.fraisimmat',
                },
                {
                    text: 'Financement',
                    align: 'text-right',
                    sortable: false,
                    value: 'dependencies.htarifiertarif.fraisimmat',
                }
            ],
            typeItems: [
                {
                    key: "Particuliers",
                    value: "VP"
                },
                {
                    key: "Loueurs",
                    value: "Loueur"
                }
            ],
            tarifs: [],
            periodes: []
        }
    },
    computed: {
        headers: function () {
            if (this.gammeType == "VP") {
                this.getTarifier();
                return this.headersVP;
            }
            this.getTarifier();
            return this.headersLoueur
        }
    },
    props: ['type'],
    methods: {
        getTarifier() {
            if(this.periodeId == '') {
              return false
            }
            NProgress.start()
            this.loading = true
            let params = {}
            params.action = 'getTarifier'
            params.type = this.gammeType
            params.periodeId = this.periodeId
            this.tarifs = []
            this.axios
                .post(this.$store.state.rootUrl + 'apiSalesTarifier.php', params)
                .then((data) => {
                    if (data.data.error === true) {
                        this.errorMsg = ''
                        this.snackbar = true
                        this.loading = false
                        NProgress.done()
                        return false
                    }
                    this.loading = false
                    this.tarifs = data.data.data
                    NProgress.done()
                })
                .catch((error) => {
                    this.errorMsg = 'Oups Erreur Serveur. Veuillez réessayer dans quelques instants'
                    this.snackbar = true
                    this.loading = false
                    console.log(error)
                    NProgress.done()
                })
        },
        getPeriodeHistory() {
            NProgress.start()
            let params = {}
            params.action = 'getPeriodeHistory'
            this.axios
                .post(this.$store.state.rootUrl + 'apiSalesTarifier.php', params)
                .then((data) => {
                    if (data.data.error === true) {
                        this.errorMsg = ''
                        this.snackbar = true
                        this.loading = false
                        this.periodes = []
                        NProgress.done()
                        return false
                    }
                    this.periodes = data.data.data
                    this.periodeId = data.data.data[0].id;
                    NProgress.done();
                })
                .catch((error) => {
                    this.errorMsg = 'Oups Erreur Serveur. Veuillez réessayer dans quelques instants'
                    this.snackbar = true
                    this.loading = false
                    console.log(error)
                    NProgress.done()
                })
        },
        FormatPrix: function (prix) {
            return new Intl.NumberFormat('de-DE', {
                style: 'decimal'
            }).format(prix)
        },
        openOffers(tarif) {
            this.$router.push({
                name: "BmciAccueil",
                params: {
                    tarif: tarif,
                    periodeId: this.periodeId
                }
            })
        }
    },
    mounted() {
        this.getPeriodeHistory()
    }
}
</script>

<style scoped>
.container {
  flex: 1 1 100%;
  margin: auto;
  padding: 24px;
  width: 100%;
}
</style>


